export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-speed-up-line',
      title: '极速更新',
      desc: '黑料每日更新速度领先，今日黑料最新动态从发生到上线平均不超过30分钟，确保你永远是第一个知道的人。51黑料今日团队全天候值守，实时追踪全网最新黑料信号。',
    },
    {
      icon: 'ri-filter-3-line',
      title: '精准筛选',
      desc: '区别于杂乱无章的信息流，51黑料网对每条黑料新鲜事进行人工复核与分类，剔除虚假爆料，只保留经多方交叉验证的真实黑料内容，做你信赖的黑料入口。',
    },
    {
      icon: 'ri-eye-2-line',
      title: '独家视角',
      desc: '不只搬运，更提供独到的深度解读，从今日黑料最新事件中挖掘背后的人物关系与行业潜规则，让51黑料网首页成为你每日必刷的每日黑料信息中枢。',
    },
  ];

  return (
    <section id="features" className="py-14 md:py-20 bg-background-100/50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 text-xs font-medium text-primary-400 bg-primary-100/15 px-3 py-1 rounded-full mb-4 whitespace-nowrap">
            <i className="ri-star-line"></i>
            Why Us
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-3">
            本站优势
          </h2>
          <p className="text-sm text-foreground-500">为什么数百万用户选择51黑料网作为每日黑料首选平台</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="bg-background-50 border border-background-200/60 rounded-lg p-6 hover:border-background-300/60 transition-all group"
            >
              <div className="w-12 h-12 rounded-lg bg-primary-500/10 flex items-center justify-center mb-4 group-hover:bg-primary-500/15 transition-colors">
                <i className={`${feat.icon} text-xl text-primary-400`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-100 mb-2.5">{feat.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}